import React, {useEffect, useState} from 'react';
import { VARIANT } from '../../../constants';
import cn from 'classnames';
import Button from "./index";



const CountDown = ({ count, onClick }) => {
  
  const [countdown, setCountdown] = useState(count);
  
  useEffect(() => {
    let interval = null;
    if(countdown > 0) {
      interval = setTimeout(() => {
        setCountdown(countdown => countdown - 1);
      }, 1000);
    }
    
    return () => {
      clearInterval(interval);
    }
  }, [countdown]);
  
  const handleClick = (e) => {
    e.preventDefault();
    onClick && onClick();
    setCountdown(count);
  }
  
  
  return (
    <div className='link'>
      {countdown > 0 ?
        <span>Gửi lại mã sau {` ${countdown}s`}</span> :
        <span onClick={handleClick}>Gửi lại</span>}
    </div>
  )
}

export default CountDown